import { render, staticRenderFns } from "./illnesses.vue?vue&type=template&id=e8cdfcb6&"
import script from "./illnesses.vue?vue&type=script&lang=js&"
export * from "./illnesses.vue?vue&type=script&lang=js&"
import style0 from "./illnesses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports